import { render, staticRenderFns } from "./distinta.vue?vue&type=template&id=b35936c8"
import script from "./distinta.vue?vue&type=script&lang=js"
export * from "./distinta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports